import {
  getCateList
} from '../services/home'
import _ from 'lodash'
import { METRIC_TIPS } from '../constants/metricTips'

export default {
  namespace: 'home',
  state: {
    loading: false,
    cateList: [
      { nameEN: 'Streamers', nameCN: '主播数量', cate: 'sumAnchor', tips: METRIC_TIPS.sumAnchor, list: [] },
      { nameEN: 'Watch Time', nameCN: '主播时长', cate: 'sumLenth', tips: METRIC_TIPS.sumLenth, list: [] },
      { nameEN: 'Tips', nameCN: '游戏打赏收入', cate: 'sumGift', tips: METRIC_TIPS.sumGift, list: [] },
      { nameEN: 'Subscribers', nameCN: '游戏粉丝数', cate: 'sumFans', tips: METRIC_TIPS.sumFans, list: [] },
      { nameEN: 'Heat Index', nameCN: '游戏热力值', cate: 'sumHot', tips: METRIC_TIPS.sumHot, list: [] },
      { nameEN: 'Niko Index', nameCN: 'NIKO指数', cate: 'sumNiko', tips: METRIC_TIPS.sumNiko, list: [] },
    ],
  },
  effects: {
    *apiGetAnchorList({ payload }, { call, put }){
      yield put({ type: 'setLoading', payload: { loading: true } })
      const response = yield call(getCateList, payload)
      yield put({ type: 'setState', payload: response.datas })
      yield put({ type: 'setLoading', payload: { loading: false } })
    },
  },
  reducers: {
    setState(state, { payload }){
      let { cateList } = state
      if(payload){
        for (let index in payload){
          let old = _.find(cateList, { cate: index })
          if(old){
            old.list = payload[index]
          }
        }
      }
      return {
        ...state,
        cateList: _.cloneDeep(cateList)
      }
    },
    setLoading(state, { payload }){
      return {
        ...state,
        ...payload
      }
    }
  }
}
